import { X } from "lucide-react";

const pains = [
    "Você entende quase tudo… mas na hora de falar, simplesmente trava.",
    "Fica traduzindo cada frase na cabeça antes de abrir a boca.",
    "Tem vergonha do sotaque e do que os outros vão pensar.",
    "Sente que sabe gramática, mas não consegue formar uma frase real.",
    "Já tentou Duolingo, escola, professor particular — e voltou ao mesmo lugar.",
    "Sente que está perdendo oportunidades de carreira, viagens e renda.",
];

export default function Pain() {
    return (
        <section
            id="pain"
            data-testid="section-pain"
            className="relative bg-cream py-20 lg:py-28"
        >
            <div className="max-w-5xl mx-auto px-5 sm:px-8 lg:px-12">
                <div className="text-center max-w-3xl mx-auto reveal">
                    <div className="flex items-center justify-center gap-3 mb-5">
                        <span className="hairline w-10" />
                        <span className="label-eyebrow">
                            Se identifica com isso?
                        </span>
                        <span className="hairline w-10" />
                    </div>
                    <h2 className="font-serif text-emerald-brand text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight">
                        Você sabe inglês.
                        <br />
                        Só não consegue
                        <span className="italic text-gold-brand"> falar</span>.
                    </h2>
                    <p className="mt-5 text-emerald-light/85 text-lg leading-relaxed">
                        Não é falta de estudo. É falta de método. E enquanto
                        ninguém te explica isso, o ciclo se repete.
                    </p>
                </div>

                <div
                    className="mt-14 grid sm:grid-cols-2 gap-4"
                    data-testid="pain-list"
                >
                    {pains.map((p, i) => (
                        <div
                            key={i}
                            className="reveal bg-white border border-cream rounded-2xl p-5 flex gap-4 items-start hover:shadow-md transition-shadow"
                            data-testid={`pain-item-${i}`}
                        >
                            <div className="shrink-0 w-9 h-9 rounded-full bg-gold-brand/10 flex items-center justify-center">
                                <X className="w-5 h-5 text-gold-brand" />
                            </div>
                            <p className="text-emerald-light text-base leading-snug">
                                {p}
                            </p>
                        </div>
                    ))}
                </div>

                <p className="mt-12 text-center font-serif italic text-emerald-brand/80 text-xl reveal">
                    Se você leu e pensou “esse sou eu”, continue lendo.
                </p>
            </div>
        </section>
    );
}
